import { Module } from 'vuex';
import { IRootState } from './store';
import restService from '@/services/restService';
import router from '../router';

export interface IAuthState {
  profile: IUserAuthProfile | null;
}

const authState: IAuthState = {
  profile: null,
};

const authGetters = {
  isAuthenticated: (state: IAuthState) => state.profile ? true : false,
  isAdmin: (state: IAuthState) => {
    if (state.profile) {
      return state.profile.isAdmin;
    }
    return false;
  }
};

const authMutations = {
  setProfile: (state: IAuthState, profile: IUserAuthProfile)  => state.profile = profile && profile.id ? profile : null,
};

const authActions = {
  async login({ commit }: { commit: any }, login: ILoginInformation) {
    const user: IUserAuthProfile = await restService.auth.postLogin(login);
    commit('setProfile', user);
  },
  async logout({ commit }: { commit: any }) {
    const user = await restService.auth.postLogout();
    commit('setProfile', null);
  },
  async getProfile({ commit, state }: { commit: any, state: IAuthState }) {
    if (!state.profile) {
      const profile = await restService.auth.getProfile();
      commit('setProfile', profile);
    }
  },
  async unauthorizedRequest({ dispatch, commit, rootState }: { dispatch: any, commit: any, rootState: IRootState }) {
    commit('setProfile', null);
    commit('admin/setUsers', [], { root: true });
    commit('admin/setShares', [], { root: true });
    commit('app/setInitialized', true, { root: true });
    const route = router.currentRoute.fullPath;
    router.push({ name: 'Login'}).then(() => router.replace({ path: route }));
  },
};

const authStore: Module<IAuthState, IRootState> = {
  namespaced: true,
  state: authState,
  getters: authGetters,
  mutations: authMutations,
  actions: authActions,
};
export default authStore;
